import { AttentionMessageProps } from './AttentionMessage.types';
import { ExclamationIcon } from '../../../icons/SvgIcons';

export const AttentionMessage = ({
  icon = <ExclamationIcon />,
  action,
  message = (
    <p className="text-rose-700 text-xs leading-4">
      <span className="font-medium mr-1">Attention Required:</span>Substantial
      Modification Detected
    </p>
  ),
  className = 'bg-rose-100 flex items-center justify-between py-2 pl-2 pr-4 rounded-md h-8'
}: AttentionMessageProps) => {
  return (
    <div className={className}>
      <div className="flex gap-2">
        {icon}
        {message}
      </div>
      {action}
    </div>
  );
};
